<div fxLayout="row wrap">
  <div fxFlex class="flex-p"> <h4>Search results...</h4></div>
</div>